import translations from './translations'

translations.add('pt', {
    closePaymentMethods: 'fechar formas de pagamento',
    otherPaymentMethods: 'outros métodos de pagamento'
})
